import type { AuthTokens } from "@/types/auth";

const ACCESS_TOKEN_KEY = "fornecedor_access_token";
const REFRESH_TOKEN_KEY = "fornecedor_refresh_token";

function canUseStorage(): boolean {
  return typeof window !== "undefined";
}

export function saveAuthTokens(tokens: AuthTokens): void {
  if (!canUseStorage()) {
    return;
  }

  resetOfflineOnIdentityChange(tokens.access);
  localStorage.setItem(ACCESS_TOKEN_KEY, tokens.access);
  localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refresh);
}

export function getAccessToken(): string | null {
  if (!canUseStorage()) {
    return null;
  }

  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getRefreshToken(): string | null {
  if (!canUseStorage()) {
    return null;
  }

  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function saveAccessToken(accessToken: string): void {
  if (!canUseStorage()) {
    return;
  }

  resetOfflineOnIdentityChange(accessToken);
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
}

export function saveRefreshToken(refreshToken: string): void {
  if (!canUseStorage()) {
    return;
  }

  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
}

export function clearAuthTokens(): void {
  if (!canUseStorage()) {
    return;
  }

  clearOfflineAccess();
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
}

// A identidade decodificada serve somente para vincular a contingência local.
// A autorização efetiva continua sendo validada pelo backend no replay da fila.
export function authOperatorId(token = getAccessToken()): number | null {
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    const id = Number(payload.user_id);
    return Number.isSafeInteger(id) && id > 0 ? id : null;
  } catch { return null; }
}

function clearOfflineAccess(): void {
  try {
    localStorage.removeItem("food-pos-bootstrap-v1");
    navigator.serviceWorker?.controller?.postMessage({ type: "food-pos-clear-offline-shell" });
    if ("caches" in window) void caches.keys().then(names => Promise.all(names
      .filter(name => name === "food-pos-shell-v1" || name === "food-pos-public-shell-v2")
      .map(name => caches.delete(name)))).catch(() => {});
    window.dispatchEvent(new Event("fornecedor-auth-changed"));
  } catch { /* armazenamento indisponível */ }
}

function resetOfflineOnIdentityChange(nextToken: string): void {
  if (authOperatorId() !== authOperatorId(nextToken)) clearOfflineAccess();
}
